@if (items.length > 0) {
  <div class="recent-activity-banner"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()">
    <div class="ticker-viewport">
      <div class="ticker-hover-zone ticker-hover-left"
        (mouseenter)="onHoverDirection('left')"
        (mouseleave)="onHoverDirectionLeave()">
        <mat-icon class="hover-arrow">chevron_left</mat-icon>
      </div>
      <!-- transform is written directly by the animation loop, NOT bound -->
      <div class="ticker-track" #tickerTrack>
        @for (activity of items; track activity) {
          <div class="banner-item" [ngClass]="'accent-' + activity.iconColor"
            [class.lifecycle-glow]="activity.iconColor === 'activity-created' || activity.iconColor === 'activity-status'"
            [matTooltip]="activity.event + ' by ' + activity.user + '\n' + activity.title + '\n' + activity.time"
            matTooltipClass="banner-tooltip-multiline">
            <div class="banner-icon" [ngClass]="activity.iconColor">
              <mat-icon>{{ activity.icon }}</mat-icon>
            </div>
            <div class="banner-text">
              <span class="banner-title">{{ activity.title }}</span>
              <span class="banner-meta">{{ activity.user }} · {{ activity.time }}</span>
            </div>
          </div>
        }
        <!-- Duplicate set for seamless infinite scroll -->
        @for (activity of items; track activity) {
          <div class="banner-item" [ngClass]="'accent-' + activity.iconColor"
            [class.lifecycle-glow]="activity.iconColor === 'activity-created' || activity.iconColor === 'activity-status'"
            [matTooltip]="activity.event + ' by ' + activity.user + '\n' + activity.title + '\n' + activity.time"
            matTooltipClass="banner-tooltip-multiline">
            <div class="banner-icon" [ngClass]="activity.iconColor">
              <mat-icon>{{ activity.icon }}</mat-icon>
            </div>
            <div class="banner-text">
              <span class="banner-title">{{ activity.title }}</span>
              <span class="banner-meta">{{ activity.user }} · {{ activity.time }}</span>
            </div>
          </div>
        }
      </div>
      <div class="ticker-hover-zone ticker-hover-right"
        (mouseenter)="onHoverDirection('right')"
        (mouseleave)="onHoverDirectionLeave()">
        <mat-icon class="hover-arrow">chevron_right</mat-icon>
      </div>
    </div>
  </div>
}
